import { createContext, FC, ReactNode, useContext, useState } from 'react';

type PromoContextActions = {
  open: boolean;
  openPromoDialog: () => void;
  closePromoDialog: () => void;
};

const PromoContext = createContext({} as PromoContextActions);

interface PromoContextProviderProps {
  children: ReactNode;
}

const PromoProvider: FC<PromoContextProviderProps> = ({ children }) => {
  const [open, setOpen] = useState<boolean>(false);

  const openPromoDialog = () => {
    setOpen(true);
  };

  const closePromoDialog = () => {
    setOpen(false);
  };

  return (
    <PromoContext.Provider value={{ open, openPromoDialog, closePromoDialog }}>
      {children}
    </PromoContext.Provider>
  );
};

const usePromoContext = (): PromoContextActions => {
  const context = useContext(PromoContext);

  if (!context) {
    throw new Error('usePromoContext must be used within an PromoProvider');
  }

  return context;
};

export { PromoProvider, usePromoContext };
